<template>
    <div class="page">
        <z-incoming-store ref="incomingStore" @storeSuccess="onStoreSuccess"></z-incoming-store>
        <z-update-org ref="updateOrg" @updateSuccess="onUpdateSuccess"></z-update-org>
        <ZxReviseDeviceType v-if="showReviseTypeModal" @quit="reviseQuit" @reviseOk="reviseOk" :record="currentRecord" />
        <ZxSetRemark v-if="showDeviceRemarkModal"  @quit="setRemarkQuit" @Ok="setRemarkOk" :record="currentRecord" />
        <div id='components-form-demo-advanced-search'>
            <a-card v-show="overViewData && overViewData.length > 0">
                <a-row :gutter="24">
                    <a-col  :xs="24" :lg="12" style="height:100% !important;">
                        <div id="overViewChart"  style="height:250px;"></div>
                    </a-col>

                    <a-col :xs="24" :lg="12">
                        <a-table :scroll="{ y: 150 }" :pagination="false" :columns="overViewColumns" :dataSource="overViewData">
                            <template slot="num" slot-scope="text">
                                <span>{{text ? text : 0}}</span>
                            </template>
                        </a-table>
                        <a-table v-show="overViewData && overViewData.length > 0" :showHeader="false"  :scroll="{ y: 180 }" :pagination="false" :columns="overViewColumns" :dataSource="totalData">
                            <template slot="num" slot-scope="text">
                                <span>{{text ? text : 0}}</span>
                            </template>
                        </a-table>
                    </a-col>
                </a-row>
            </a-card>

            <z-search-form :searchOption="searchOption" @search="handleSearch"></z-search-form>
            <div class="content" style="padding: 15px">
                <div>
                    <a-row style="padding-bottom: 15px" type="flex" justify="start" :gutter="8">
                        <a-col v-if="isSuperAdmin">
                            <a-button @click="showIncomingStoreModel()" type="primary">
                                <a-icon type="download"/>
                                {{$t('device.incoming')}}
                            </a-button>
                        </a-col>
                        <a-col>
                            <a-button @click="exportDevices()">
                                <a-icon type="download"/>
                                {{$t('global.export')}}
                            </a-button>
                        </a-col>
                        <a-col>
                            <a-button @click="showUpdateOrgModel()">
                                <a-icon type="edit"/>
                                {{$t('device.modifyOrg')}}
                            </a-button>
                        </a-col>
                        <a-col v-if="selectedRowKeys.length && isSuperAdmin">
                            <a-dropdown>
                                <a-menu slot="overlay" @click="handleMenuClick">
                                    <a-menu-item key="2" @click="batchDelete">{{$t('global.delete')}}</a-menu-item>
                                </a-menu>
                                <a-button>
                                    {{$t('global.moreOperation')}}
                                    <a-icon type="down"/>
                                </a-button>
                            </a-dropdown>
                        </a-col>
                    </a-row>
                    <z-column-check :columnOption="columnOption" ref="columnCheck"></z-column-check>

                    <div class="section-list">
                        <a-alert :showIcon="true" :message="tips" type="info"/>
                    </div>
                </div>

                <div class='section-list'>
                    <a-spin :spinning="isLoading" :tip="$t('global.loading')">
                        <a-table :rowSelection="rowSelection" :scroll="{ x: 1300 }"
                                 :columns="columnOption.listColumns" :dataSource="data" :pagination="pagination" @change="onChange">
                            <template slot="delete" slot-scope="text,record">
                                <div v-if="isSuperAdmin">
                                  <a-button-group size="small">
                                    <a-button type="danger" @click="onDelete(record)" :disabled="record.entityId ? true : false">{{$t('global.delete')}}</a-button>
                                    <a-button @click="reviseDeviceType(record)" >{{$t('global.edit')}}</a-button>
                                  </a-button-group>
                                </div>
                                <div v-else>
                                  <a-button :disabled="false" size="small" @click="setDeviceRemark(record)" >{{$t('device.changeRemark')}}</a-button>
                                </div>
                            </template>
                            <template slot="date" slot-scope="text">
                                <span>{{text ? timeFormat(text) : ''}}</span>
                            </template>
                            <template slot="status" slot-scope="text">
                                <a-tag v-if="text" color="green">{{$t('device.deviceStatusNormal')}}</a-tag>
                                <a-tag  v-else color="pink">{{$t('device.deviceStatusUnbound')}}</a-tag>
                            </template>
                        </a-table>
                    </a-spin>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import config from '@/config'
    import ZSearchForm from '@/components/common/SearchForm.vue'
    import ZColumnCheck from '@/components/common/ColumnCheck.vue'
    import ZIncomingStore from '@/views/device/IncomingStore.vue'
    import ZUpdateOrg from '@/views/device/UpdateOrg.vue'
    import ZxReviseDeviceType from './ReviseDeviceType'
    import ZxSetRemark from './SetRemark'
    import moment from 'moment'
    import {mapGetters} from 'vuex'
    import {export_json_to_excel} from '@/utils/Export2Excel'
    import bus from '../../bus/bus';
    const echarts = require('echarts')

    export default {
        data() {
            return {
              totalData:[],
              overViewData: [],
              showReviseTypeModal: false,
              showDeviceRemarkModal: false,
              currentRecord: '',
                data: [],
                expand: false,
                selectedRowKeys:[],
                selectedRows: [],
                searchParams: {},
                form: this.$form.createForm(this),
                isLoading: false,
                pagination:{
                    showSizeChanger: false,
                    pageSizeOptions:['2','10','50','100'],
                    pageSize: 10,
                    current: 1,
                    total : 0,
                    showTotal:this.showTotal,
                    showQuickJumper:true
                },
                columnOption: {
                    listColumns: [],
                    columns: [{
                        "title": "manufacturer",
                        "dataIndex": "oui",
                        "key": "oui",
                        "left": true
                    }, {
                        "title": "deviceExtra",
                        "key": "extra",
                        "dataIndex": "extra",
                        "checkColumn": true
                    }, {
                        "title": "serialNumber",
                        "dataIndex": "sn",
                        "key": "sn",
                        "left": true
                    }, {
                        "title": "deviceModel",
                        "key": "model",
                        "dataIndex": "model",
                        "checkColumn": true,
                    },
                        {
                            "title": "IMSI",
                            "key": "imsi",
                            "dataIndex": "imsi",
                            "checkColumn": false
                        }, {
                            "title": "ICCID",
                            "key": "iccid",
                            "dataIndex": "iccid",
                            "checkColumn": false
                        },
                        {
                            "title": "devicePhoneNo",
                            "key": "phoneNo",
                            "dataIndex": "phoneNo",
                            "checkColumn": true
                        }, {
                            "title": "softwareVersion",
                            "key": "version",
                            "dataIndex": "version"
                        }, {
                            "title": "productionDate",
                            "key": "createTimestamp",
                            "dataIndex": "createTimestamp",
                            "scopedSlots": {
                                "customRender": "date"
                            },
                            "checkColumn": false,
                            "sorter": true
                        }, {
                            "title": "packageDate",
                            "key": "paymentTimestamp",
                            "dataIndex": "paymentTimestamp",
                            "scopedSlots": {
                                "customRender": "date"
                            },
                            "checkColumn": false,
                            "sorter": true
                        }, {
                            "title": "deviceOrg",
                            "key": "orgName",
                            "dataIndex": "orgName",
                            "checkColumn": true
                        }, {
                            "title": "deviceStatus",
                            "key": "entityId",
                            "dataIndex": "entityId",
                            "scopedSlots": {
                                "customRender": "status"
                            },
                            "checkColumn": true
                        }, {
                            "title": "deviceRemark",
                            "key": "remark",
                            "dataIndex": "remark",
                            "checkColumn": true
                        }, {
                            "title": "operate",
                            "dataIndex": "operation",
                            "key": "operation",
                            "scopedSlots": {
                                "customRender": "delete"
                            },
                            // "right": true,
                            "checkColumn": true
                        }]
                },
                searchOption: [
                    {
                        key: "sn",
                        name: "序列号",
                        type: "input",
                        matchValue: "li",
                        value: "",
                        placeholder: '请输入序列号SN',
                        default: true
                    },
                    {
                        key: "org",
                        name: "所属机构",
                        type: "orgChooser",
                        matchType: "eq",
                        option:{
                            showDirect:true,
                            directFlag:false,
                            value: ""
                        }
                    },
                    {
                        key: "deviceModel",
                        name: "设备类型",
                        type: "deviceTypeChooser",
                        matchValue: "eq",
                        // placeholder: '请选择设备类型',
                        option: {
                            allowClear: true,
                            value: undefined
                        }
                    },
                    {
                      key: 'dimMatch',
                      name: '模糊查询',
                      type: 'input',
                      matchValue: 'li',
                      placeholder: '请输入要查询的内容',
                      option: {
                        showDirect: true,
                        allowClear: true,
                      }
                    },
                    // {
                    //     key: "power",
                    //     name: "电量",
                    //     type : "custom",
                    //     matchValue: "",
                    //     searchTypeData :[
                    //         {
                    //             key: "大于",
                    //             type: "input",
                    //             paramName: 'minPower',
                    //             value: null
                    //         },
                    //         {
                    //             key: "小于",
                    //             type: "input",
                    //             paramName: "maxPower",
                    //             value: null
                    //         },
                    //         {
                    //             key: "之间",
                    //             type: "inputRange",
                    //             paramName: "minPower,maxPower",
                    //             value: []
                    //         }
                    //     ]
                    // },
                    {
                        key: "createTime",
                        name: "生产日期",
                        type : "custom",
                        placeholder: '请选择',
                        matchValue: undefined,
                        placeholder: '选择时间',
                        dataType: "time",
                        searchTypeData :[
                            {
                                key: "之后",
                                type: "datePicker",
                                paramName: "minTime",
                                value: null
                            },
                            {
                                key: "之前",
                                type: "datePicker",
                                paramName: "maxTime",
                                value: null
                            },
                            {
                                key: "之间",
                                type: "rangePicker",
                                paramName: "minTime,maxTime",
                                value: []
                            }
                        ]
                    }
                ],
            }
        },
        components: {
            ZSearchForm,
            ZColumnCheck,
            ZIncomingStore,
            ZUpdateOrg,
            ZxReviseDeviceType,
            ZxSetRemark
        },
        created() {
            this.pageQuery()
            this.overView()
        },
        beforeDestroy () {
          bus.$off('langChanged')
        },
        mounted () {
          bus.$on('langChanged', (lang) => {
                // console.log(lang)
                this.$nextTick().then(() => {
                    this.overView()
                    this.$refs["columnCheck"].refresh()
                })
            })
        },
        computed: {
            deviceTotalDesc() {
                return  this.$t('device.total')
            },
            overViewColumns() {return [
                {
                    title: this.$t('device.deviceModel'),
                    dataIndex: 'name',
                    key: 'name',
                    width:'20%'
                },
                {
                    title: this.$t('device.total'),
                    dataIndex: 'total',
                    key: 'total',
                    width:'15%'
                },
                {
                    title: this.$t('device.vacancy'),
                    dataIndex: 'store',
                    key: 'store',
                    width:'15%'
                },
                {
                    title: 'M',
                    dataIndex: 'M',
                    key: 'M',
                    width:'15%',
                    scopedSlots: { customRender: "num" }
                },
                {
                    title: 'S',
                    dataIndex: 'S',
                    key: 'S',
                    width:'15%',
                    scopedSlots: { customRender: "num" }
                },
                {
                    title: 'L',
                    dataIndex: 'L',
                    key: 'L',
                    scopedSlots: { customRender: "num" }
                },
                {
                    title: this.$t('device.other'),
                    dataIndex: 'other',
                    key: 'other',
                    scopedSlots: { customRender: "num" }
                }
            ]},
            tips() {
                return this.$t('global.selectedNum', {num: this.selectedRowKeys.length})
            },
            ...mapGetters([
                'isSuperAdmin',
            ]),
            rowSelection() {
                return {
                    fixed:true,
                    selectedRowKeys: this.selectedRowKeys,
                    onChange: (selectedRowKeys, selectedRows) => {
                        this.selectedRowKeys = selectedRowKeys
                        this.selectedRows = selectedRows
                    },
                    getCheckboxProps: record => ({
                        props: {
                            disabled: record.entityId ? true : false
                        }
                    }),
                }
            }
        },
        methods: {
          setOverViewChartOption(data){
              if(!data || data.length == 0){
                  return
              }
              let legendData = []
              let seriesData = []
              let totalData = []
              let storeData = []
              data.map(item => {
                  legendData.push(item.name)
                  totalData.push(item.total)
                  storeData.push(item.store)
              })
              seriesData.push({
                  name:this.$t('device.total'),
                  type: "bar",
                  data: totalData
              })
              seriesData.push({
                  name:this.$t('device.vacancy'),
                  type: "bar",
                  data: storeData
              })
              let option = {
                  title: {
                      text: this.$t('device.overView')
                  },
                  grid: {
                    left: 120
                  },
                  tooltip: {
                      trigger: 'axis',
                      axisPointer: {
                          type: 'shadow'
                      }
                  },
                  legend: {
                      data: [this.$t('device.vacancy'),this.$t('device.total')]
                  },
                  xAxis: {
                      type: 'value',
                      name: this.$t('device.deviceNumber'),
                      axisLabel: {
                          formatter: '{value}'
                      }
                  },
                  yAxis: {
                      type: 'category',
                      name: this.$t('device.deviceModel'),
                      data:legendData,
                  },
                  series: seriesData
              }
              let overViewChart = echarts.init(document.getElementById('overViewChart'));
              overViewChart.setOption(option);

              window.addEventListener('resize', function () {
                  overViewChart.resize();
              });
          },
          // 修改设备类型
          reviseDeviceType(record) {
            // console.log(record)
            this.currentRecord = record
            this.showReviseTypeModal = true
          },
          reviseOk () {
            this.currentRecord = ''
            this.showReviseTypeModal = false
            this.pageQuery()
          },
          reviseQuit () {
            this.currentRecord = ''
            this.showReviseTypeModal = false
          },
          setDeviceRemark (record) {
            // console.log(record)
            this.currentRecord = record
            this.showDeviceRemarkModal = true
          },
          setRemarkQuit () {
            this.currentRecord = ''
            this.showDeviceRemarkModal = false
          },
          setRemarkOk () {
            this.currentRecord = ''
            this.showDeviceRemarkModal = false
            this.pageQuery()
          },
            batchDelete(){
                let _this = this
                this.$confirm({
                    title: '确认删除选择的记录吗?',
                    onOk() {
                        _this.deleteDevices(_this.selectedRowKeys.join(","))
                        _this.selectedRowKeys = []
                    },
                    onCancel() {}
                });
            },
            onDelete(record) {
              let _this = this
              this.$confirm({
                title: '确认删除吗?',
                onOk() {
                  _this.deleteDevices(record.oui + "_" + record.sn)
                  _this.selectedRowKeys.filter(item => item !== record.oui + "_" + record.sn)
                },
                onCancel() {}
              })
                
            },
            deleteDevices(ids) {
                this.$http.delete(config.api.device_url + "/" + ids).then(() => {
                    this.$message.success('删除设备成功')
                    this.pageQuery()
                }).catch((err) => {
                    console.log(err)
                })
            },
            showTotal(total) {
                return this.$t('global.totalRecords', {num: total})
            },
            onStoreSuccess() {
                this.pageQuery()
            },
            onUpdateSuccess() {
                this.selectedRowKeys = []
                this.selectedRows = []
                this.pageQuery()
            },
            showIncomingStoreModel() {
                this.$refs["incomingStore"].showIncomingStoreModel()
            },
            showUpdateOrgModel() {
                this.$refs["updateOrg"].showUpdateOrgModel(this.selectedRows)
            },
            exportDevices() {
                let tempParam = Object.assign({}, this.searchParams);
                delete tempParam["pageSize"]
                delete tempParam["currentPage"]
                this.$http.post(config.api.device_query_url,tempParam).then((response) => {
                    let exportData = [];
                    let tHeader = [];
                    let exportHeader = {
                        oui:this.$t('columnCheck.manufacturer'),
                        sn:this.$t('columnCheck.serialNumber'),
                        extra: this.$t('columnCheck.deviceExtra'),
                        model:this.$t('columnCheck.deviceModel'),
                        imsi:'IMSI',
                        iccid:'ICCID',
                        version:this.$t('columnCheck.softwareVersion'),
                        createTimestamp:this.$t('columnCheck.productionDate'),
                        paymentTimestamp:this.$t('columnCheck.packageDate'),
                        orgName:this.$t('columnCheck.deviceOrg'),
                        status:this.$t('columnCheck.deviceStatus'),
                        remark:this.$t('columnCheck.deviceRemark')
                    }
                    console.log(JSON.stringify(exportHeader))
                    for (let key in exportHeader){
                        tHeader.push(exportHeader[key]);
                    }
                    let _this = this
                    // console.log(response)
                    response.result.map((item) => {
                        let itemData = [];
                        for (let key in exportHeader){
                            if(key == 'createTimestamp' || key == 'paymentTimestamp'){
                                if(item[key]){
                                    itemData.push(_this.timeFormat(item[key]));
                                } else {
                                    itemData.push('')
                                }
                            }else if(key == 'status'){
                                if(item['entityId']){
                                    itemData.push(this.$t('device.deviceStatusNormal'));
                                }else{
                                    itemData.push(this.$t('device.deviceStatusUnbound'));
                                }
                            }else{
                                if(item[key]){
                                    itemData.push(item[key]);
                                } else {
                                    itemData.push('');
                                }
                            }
                        }
                        exportData.push(itemData);
                    })
                    // console.log(tHeader)
                    // console.log(exportData)
                    // debugger
                    let title = moment().format('YYYY-MM-DD') + this.$t('global.exportList') + '(' + exportData.length + ')'
                    export_json_to_excel(tHeader, exportData, title);
                })
            },
            onChange(page, filters, sorter){
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                if(sorter.order){
                    this.searchParams['orderBy'] = sorter.field
                    if(sorter.order == "ascend"){
                        this.searchParams['sort'] = "ASC"
                    }else{
                        this.searchParams['sort'] = "DESC"
                    }
                }else{
                    delete this.searchParams["orderBy"]
                    delete this.searchParams["sort"]
                }
                this.pageQuery()
            },
            overView() {
                this.$http.get(config.api.device_overView_url).then((response) => {
                    if(response.code == 0){
                        let total = {name: this.deviceTotalDesc, total: 0, store:0,M:0,S:0,L:0, other: 0}
                        let respData = response.result

                        respData.sort((item1,item2) =>{
                            return item1.total < item2.total
                        })
                        respData.map(item => {
                            total.total += item.total
                            total.store += item.store
                            total.M += item.M ? item.M : 0
                            total.S += item.S ? item.S : 0
                            total.L += item.L ? item.L : 0
                            total.other += item.other ? item.other : 0
                        })
                        //respData.push(total)
                        this.totalData = []
                        this.totalData.push(total)

                        this.overViewData =  respData
                        this.$nextTick().then(() => {
                            this.setOverViewChartOption(respData)
                        })
                    }
                })
            },
            pageQuery(){
                this.isLoading = true
                this.searchParams["pageSize"] = this.pagination.pageSize.toString()
                this.searchParams["currentPage"] = this.pagination.current.toString()
                this.$http.post(config.api.device_page_url,this.searchParams).then((response) => {
                    if(response.code == 0){
                        response.result.resultList.map(function(item){
                            item.key = item.oui + "_" + item.sn
                        })
                        this.data =  response.result.resultList
                        console.log(this.data)
                        this.pagination.total = response.result.page.totalSize
                        this.pagination.current = response.result.page.currentPage
                    }
                    this.isLoading = false
                })
            },
            handleSearch(params){
                this.searchParams = params
                this.selectedRowKeys = []
                this.pagination.current = 1
                this.pageQuery()
            },
            timeFormat(timestamp) {
                return moment(timestamp * 1000).format('YYYY-MM-DD')
            },
            handleMenuClick(e) {
                console.log('click', e);
            },
            onSelectChange(selectedRowKeys,selectedRows) {
                this.selectedRowKeys = selectedRowKeys
                this.selectedRows = selectedRows
            },
            handleReset() {
                this.form.resetFields()
            }
        }
    }

</script>
<style>
    .ant-advanced-search-form .ant-form-item {
        display: flex;
    }

    .ant-advanced-search-form .ant-form-item-control-wrapper {
        flex: 1;
    }

    #components-form-demo-advanced-search .ant-form {
        max-width: none;
    }

    .section-list {
        padding-top: 15px;
    }
</style>